export const getState = state => {
  return state.internshipsManager
}
